"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = handleError;
const module_shared_error_1 = require("@b2ag/module-shared-error");
function isAxiosError(error) {
    return error.isAxiosError ?? false;
}
/**
 * Helper method used to simplify axios error handling
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function handleError(error) {
    if (!isAxiosError(error)) {
        throw (0, module_shared_error_1.unknown)('Unhandled error', error);
    }
    if (!error.response) {
        throw (0, module_shared_error_1.unknown)('No Response');
    }
    const data = error.response.data;
    if ((0, module_shared_error_1.isAladinErrorData)(data)) {
        throw new module_shared_error_1.AladinError(data);
    }
    if (error.response.status === 401) {
        throw (0, module_shared_error_1.unauthorized)();
    }
    if (error.response.status === 403) {
        throw (0, module_shared_error_1.forbidden)();
    }
    throw (0, module_shared_error_1.unknown)('Unsupported error', error.response.data);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2luZnJhL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVlBLGtDQWtCQztBQTlCRCxtRUFBNEc7QUFHNUcsU0FBUyxZQUFZLENBQUMsS0FBYztJQUNsQyxPQUFRLEtBQTZCLENBQUMsWUFBWSxJQUFJLEtBQUssQ0FBQTtBQUM3RCxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsaUhBQWlIO0FBQ2pILFNBQWdCLFdBQVcsQ0FBQyxLQUFVO0lBQ3BDLElBQUcsQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUN4QixNQUFNLElBQUEsNkJBQU8sRUFBQyxpQkFBaUIsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUN6QyxDQUFDO0lBQ0QsSUFBRyxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQztRQUNuQixNQUFNLElBQUEsNkJBQU8sRUFBQyxhQUFhLENBQUMsQ0FBQTtJQUM5QixDQUFDO0lBQ0QsTUFBTSxJQUFJLEdBQUcsS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUE7SUFDaEMsSUFBRyxJQUFBLHVDQUFpQixFQUFDLElBQUksQ0FBQyxFQUFDLENBQUM7UUFDMUIsTUFBTSxJQUFJLGlDQUFXLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDN0IsQ0FBQztJQUNELElBQUksS0FBSyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFLENBQUM7UUFDbEMsTUFBTSxJQUFBLGtDQUFZLEdBQUUsQ0FBQTtJQUN0QixDQUFDO0lBQ0QsSUFBSSxLQUFLLENBQUMsUUFBUSxDQUFDLE1BQU0sS0FBSyxHQUFHLEVBQUUsQ0FBQztRQUNsQyxNQUFNLElBQUEsK0JBQVMsR0FBRSxDQUFBO0lBQ25CLENBQUM7SUFDRCxNQUFNLElBQUEsNkJBQU8sRUFBQyxtQkFBbUIsRUFBRSxLQUFLLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFBO0FBQ3pELENBQUMifQ==